import Actions from '../../action'
const initialState = {
    isLoading: false,
    error: false,
    selectedAccents: {
        button: 'j8',
        hole: 'black',
        thread: 'black',
        selectedVestLining: 'default',
        selectedVestInnerFabric: 'gid://shopify/Product/6759386448036',
        liningFabricName: null
    }
}
export default (state = initialState, action) => {
    switch (action.type) {
        case Actions.UPDATE_VEST_ACCENTS: {
            let { selectedAccents } = state
            return {
                ...state,
                selectedAccents: {
                    ...selectedAccents,
                    [action.key]: action.data
                },
            };
        } case Actions.EDIT_VEST_ACCENTS: {
            return {
                ...state,
                selectedAccents: action.data,
            };
        } case Actions.RESET_CANVAS: {
            return {
                ...state,
                ...initialState
            }
        } case Actions.RESET_STYLE: {
            return {
                ...state,
                ...initialState
            }
        }
        default:
            return state;
    }

};